export default "__VITE_ASSET__ee1f8314__"